<template>
    <v-toolbar
        color="accent darken-1"
        class="fixed-toolbar py-1"
        :height="$vuetify.breakpoint.mdAndUp ? 76 : 48"
    >
        <psi-quick-links
            v-if="quickLinkItems.length > 0"
            :three-col="$vuetify.breakpoint.mdAndUp"
            :items="quickLinkItems"
            :small="$vuetify.breakpoint.mdAndDown"
            btn-class="ml-n2 white--text"
            @action="$emit('quicklink:click', $event)"
        ></psi-quick-links>
        <v-toolbar-title class="white--text text-md-h6 text-subtitle-1">
            {{ title }}
        </v-toolbar-title>
        <v-divider
            v-if="statusItems.length > 0"
            vertical
            dark
            inset
            class="accent lighten-1 mx-4 hidden-md-and-down"
        ></v-divider>
        <template v-for="(item, index) in statusItems">
            <v-chip
                :key="`status-${index}`"
                :color="item.color"
                :class="item.class"
                >{{ item.label }}</v-chip
            >
        </template>

        <v-divider
            v-if="showProgress"
            vertical
            dark
            inset
            class="accent lighten-1 mx-4 hidden-sm-and-down"
        ></v-divider>
        <div
            v-if="showProgress"
            :style="`width: ${progress.width}px`"
            class="flex-d flex-column align-start d-none d-md-flex"
        >
            <div class="grey--text text--lighten-1 text-body-2 mt-n3 mb-1">
                Progress {{ progress.value }}%
            </div>

            <v-progress-linear
                color="accent lighten-2"
                top
                :value="progress.value"
                rounded
                height="14"
                background-color="accent darken-3"
            ></v-progress-linear>
        </div>
        <v-spacer></v-spacer>
        <v-divider
            v-if="notificationItems.length > 0"
            vertical
            dark
            inset
            class="accent lighten-1 mx-4 hidden-sm-and-down"
        ></v-divider>
        <template v-for="(item, index) in notificationItems">
            <v-badge
                :key="`badge-${index}`"
                :content="item.content"
                overlap
                :color="item.color"
                :class="item.class"
            >
                <v-btn icon dark @click="$emit(item.eventName, item.event)">
                    <v-icon
                        :large="$_.get(item, 'large', true)"
                        :small="$_.get(item, 'small', false)"
                        >{{ item.icon }}</v-icon
                    >
                </v-btn>
            </v-badge>
        </template>
        <v-divider
            v-if="menuItems.length > 0"
            vertical
            dark
            inset
            class="accent lighten-1 mx-4 hidden-sm-and-down"
        ></v-divider>
        <template v-for="(item, index) in menuItems">
            <v-tooltip
                v-if="item.type === 'button'"
                top
                color="accent"
                :key="index"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        :disabled="$_.get(item, 'disabled', false)"
                        icon
                        dark
                        class="mr-4 hidden-md-and-down"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="$emit('action', item.event)"
                    >
                        <v-icon large>{{ item.icon }}</v-icon>
                    </v-btn>
                </template>
                <span>{{ item.tooltip }}</span>
            </v-tooltip>
            <v-divider
                v-if="item.type === 'divider'"
                :key="`divider-${index}`"
                vertical
                dark
                inset
                class="accent lighten-1 mx-4 hidden-md-and-down"
            ></v-divider>
        </template>
        <slot name="actions"> </slot>
    </v-toolbar>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    name: "screening-process-toolbar",
    components: {},
    props: {
        quickLinkItems: {
            type: Array,
            required: false,
            default: () => [],
        },
        title: {
            type: String,
            required: false,
            default: "Toolbar Title",
        },
        menuItems: {
            type: Array,
            required: false,
            default: () => [],
        },
        notificationItems: {
            type: Array,
            required: false,
            default: () => [],
        },
        statusItems: {
            type: Array,
            required: false,
            default: () => [],
        },
        showProgress: {
            type: Boolean,
            required: false,
            default: false,
        },
        progress: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters("Screens", ["currentScreen", "loading"]),
    },
    watch: {},
    methods: {},
};
</script>

<style scoped>
</style>